import { CopyThemePrimaryImage } from '../../svgImages/CopyImage';
import { PlusThemePrimaryImage } from '../../svgImages/PlusImage';
import { ShareThemePrimaryImage } from '../../svgImages/ShareImage';
import type { ButtonProps } from '../types';

export const ButtonSecondary: React.FC<
  ButtonProps & {
    prefixIcon?: 'plus' | 'share' | 'copy';
  }
> = ({ text, width, prefixIcon = null, isLoading = false, ...attr }) => (
  <button
    type="button"
    className={
      width === 'fit'
        ? 'group relative flex min-h-10 w-fit appearance-none items-center justify-center rounded-2 p-3'
        : 'group relative flex min-h-10 w-full appearance-none items-center justify-center rounded-2 p-3'
    }
    {...attr}
  >
    <div className="absolute inset-0 rounded-2 bg-base-100 transition-colors group-hover:bg-accent-secondary" />
    <div className="absolute inset-0 rounded-2 border-2 border-accent-primary" />
    {isLoading && (
      <div className="absolute inset-y-0 right-2 my-auto size-4">
        <div className="size-full animate-spin rounded-[50%] border-2 border-b-base-40 border-l-accent-primary border-r-accent-secondary border-t-accent-primary" />
      </div>
    )}
    <div className="relative flex w-fit items-center gap-1">
      {prefixIcon === 'plus' && (
        <PlusThemePrimaryImage alt="" className="size-4" />
      )}
      {prefixIcon === 'share' && (
        <ShareThemePrimaryImage alt="" className="size-4" />
      )}
      {prefixIcon === 'copy' && (
        <CopyThemePrimaryImage alt="" className="size-4" />
      )}
      <div className="cst-button-label-text text-accent-primary">{text}</div>
    </div>
  </button>
);
